<template>
  <div class="space-between-y">
    <div class="space-between-x">
      <input-item label="请输入关键字进行搜索">
        <el-input @change="getData" v-model="form.keyword" placeholder="根据用户名/Email/姓名" clearable></el-input>
      </input-item>
      <input-item>
        <el-button type="primary" @click="getData">搜索</el-button>
      </input-item>
    </div>

    <el-dialog width="560px" title="用户设置" :visible.sync="userForm.dialog">
      <user-form :user="userForm.form" v-if="userForm.dialog" @updated="userUpdated()"></user-form>
    </el-dialog>

    <el-table :data="users" border stripe>
      <el-table-column width="80" show-overflow-tooltip label="用户ID" prop="id"/>
      <el-table-column width="150" label="用户名" prop="username">
        <template v-slot="scope">
          <line-overflow :content="scope.row.username" :max-lines="1"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column width="150" label="姓名" prop="fullname">
        <template v-slot="scope">
          <line-overflow :content="scope.row.fullname" :max-lines="1"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column label="单位名称" prop="dealerName">
        <template v-slot="scope">
          <line-overflow :content="scope.row.dealerName" :max-lines="1"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column label="最后在线时间" prop="lastLogin">
        <template v-slot="scope">
          <line-overflow :max-lines="1" :content="scope.row.lastLogin"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column label="团队" prop="dealerName">
        <template v-slot="scope">
          <el-tag type="info" size="mini" v-if="scope.row.dealerId">{{
              dealerName(scope.row.dealerId)
            }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="团队角色" prop="email">
        <template v-slot="scope">
          <el-tag type="info" size="mini" v-if="scope.row.dealerUserRole">{{
              roleName(scope.row.dealerUserRole)
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="用户角色" prop="roles">
        <template v-slot="scope">
          <el-tag type="info" size="mini" v-for="(role,index) in scope.row.roles" :key="index">{{
              role.name
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60" align="center" fixed="right">
        <template v-slot="scope">
          <el-button type="text" size="mini" @click="showDetail(scope.row.id)">更新</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getData()"></pagination>
  </div>
</template>

<script>
import {user} from "@/api/user";
import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";
import InputItem from "@/components/base/layout/InputItem.vue";
import UserForm from "@/components/user/UserForm.vue";
import Pagination from "@/components/base/layout/Pagination.vue";

export default {
  name: 'UserManage',
  components: {Pagination, UserForm, InputItem, LineOverflow},

  data() {
    return {
      users: [],
      userForm: {
        dialog: false,
        form: {}
      },

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      form: {
        keyword: "",
      },
      dealers: [],
    };
  },

  computed: {
    roleName() {
      return (role) => {
        const list = [
          {name: "管理员", value: "manager"},
          {name: "销售", value: "sales"},
          {name: "执行人员", value: "builder"}
        ];
        const item = list.find(x => x.value === role);
        return item ? item.name : "";
      };
    },

    dealerName() {
      return (dealerId) => {
        const dealer = this.dealers.find(d => d.id.toString() === dealerId);
        return dealer ? dealer.name : "";
      };
    }
  }
  ,

  created() {
    this.getData();
    user.listAllDealer().then(res => {
      this.dealers = res.data;
    });
  },

  methods: {

    getData() {
      user.listStaff(this.page.current, this.page.size, this.form.keyword).then(res => {
        let page = res.data;
        this.users = page.list;
        this.page.total = page.total;
      });
    },

    userUpdated() {
      this.userForm.form = {};
      this.userForm.dialog = false;
      this.getData();
    },

    showDetail(userId) {
      let user = this.users.find(user => user.id === userId);
      this.userForm.form = {
        id: user.id,
        username: user.username,
        roleIds: user.roles.map(role => role.id),
        dealerId: user.dealerId,
        dealerUserRole: user.dealerUserRole,
        fullname: user.fullname
      };
      this.userForm.dialog = true;
    },
  },


};
</script>

<style scoped>
</style>
